module.exports = __webpack_public_path__ + "img/ordTNiac5.f593605f.jpg";